import React from 'react';
import { Link } from 'react-router-dom';
import { appsAPI } from '../../api/client';
import { getLogoUrl } from '../../utils/helpers';
import UpvoteButton from './UpvoteButton';
import { ExternalLink } from 'lucide-react';

const AppCard = ({ app, showCategory = true }) => {
  const handleVisitClick = async (e) => {
    e.preventDefault();
    try {
      await appsAPI.trackClick(app.id);
      window.open(app.app_url, '_blank', 'noopener,noreferrer');
    } catch (error) {
      console.error('Failed to track click:', error);
      window.open(app.app_url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="group relative bg-dark-card rounded-lg border border-dark-border hover:border-brand-yellow/50 transition-all duration-300 overflow-hidden" data-testid="app-card">
      <div className="flex gap-3 p-3">
        {/* App Logo - Reduced to 48px */}
        <Link to={`/apps/${app.id}`} className="flex-shrink-0" data-testid="app-card-thumbnail">
          <div className="w-12 h-12 rounded-lg overflow-hidden border border-dark-border">
            {getLogoUrl(app) ? (
              <img
                src={getLogoUrl(app)}
                alt={app.app_name}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            ) : (
              <div className="w-full h-full bg-gradient-to-br from-purple-900/20 to-pink-900/20 flex items-center justify-center">
                <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
            )}
          </div>
        </Link>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-3">
            <div className="flex-1 min-w-0">
              <Link to={`/apps/${app.id}`} className="group/title" data-testid="app-card-title">
                <h3 className="text-base font-bold text-white group-hover/title:text-brand-yellow transition-colors mb-2">
                  {app.app_name}
                </h3>
              </Link>

              <p className="text-xs text-gray-400 line-clamp-2 mb-2" data-testid="app-card-tagline">
                {app.tagline}
              </p>

              {/* Categories */}
              {showCategory && (
                <div className="flex flex-wrap gap-1.5">
                  <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-900/30 text-blue-300 border border-blue-700/30">
                    {app.category_l1_name}
                  </span>
                  <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-900/30 text-purple-300 border border-purple-700/30">
                    {app.category_l2_name}
                  </span>
                </div>
              )}
            </div>

            {/* Actions */}
            <div className="flex items-center gap-2 flex-shrink-0">
              <UpvoteButton app={app} />
              <button
                onClick={handleVisitClick}
                className="px-3 py-1.5 bg-brand-yellow text-dark-bg rounded-lg hover:bg-brand-yellow/90 transition-colors font-bold text-xs flex items-center gap-1.5 whitespace-nowrap"
                data-testid="app-card-visit-button"
              >
                Visit
                <ExternalLink className="w-3.5 h-3.5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppCard;
